export enum ApplicationEnvironment {

    // Obsolete
    Nightly = 'night',
    Regression = 'reg',
    Staging = 'stag',

    Development = 'dev',
    Edge = 'edge',
    Vnext = 'vnext',
    ReleaseCandidate = 'rc',
    Production = 'prod',

}

export enum AppName {
    FieldApp = 'FieldApp',
    ManagerApp = 'ManagerApp',
}
